export const px = (value: number) => `${value}px`;

/**
 * Converts a pixel value string (e.g., "12px") to its numeric value.
 * If the input is undefined, throws an error.
 * If parsing fails, returns 0.
 *
 * @param {string | undefined} px - The pixel value as a string (e.g., "24px", "12").
 * @returns {number} The numeric value of the pixel input. Returns 0 if input is NaN.
 * @throws {Error} If the input is undefined.
 */
export const pxToInt = (px?: string) => {
  if (!px) {
    throw new Error('[alloy-react-helpers/pxToInt] value is required');
  }

  const match = /^(-?\d+(?:\.\d+)?)(?:px)?$/.exec(px.trim());

  if (!match) {
    throw new Error(`[alloy-react-helpers/pxToInt] invalid value: ${px}`);
  }

  return parseFloat(match[1]);
};
